import styled from "@emotion/styled";
import {
  AccordionContainerProps,
  AccordionHeaderProps,
} from "./Accordion.types";
import { colorGuide } from "../../theme/colors";
import { generateAccordionContainerStyles } from "../../utils";

// Accordion Container
export const AccordionContainer = styled.div<AccordionContainerProps>`
  margin-bottom: ${({ marginBottom }) => marginBottom || "8px"};
  gap: ${({ isOpen, variant }) =>
    variant === "big" ? "16px" : isOpen ? "8px" : "12px"};
  ${({ variant, bottomLineColor }) =>
    variant === "big" && bottomLineColor
      ? `border-bottom: 1px solid ${bottomLineColor};`
      : ""}
  ${(props) => generateAccordionContainerStyles(props)};
`;

// Accordion Header
export const AccordionHeader = styled.div<AccordionHeaderProps>`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: ${({ variant }) =>
    variant === "big" ? "flex-start" : "center"};
  flex: 1 0 0;
  gap: ${({ variant }) => (variant === "big" ? "12px" : "8px")};
  align-self: stretch;
  cursor: pointer;
  color: ${colorGuide.lightComponents.accordion.color};
`;

// Header Content Container (for big variant)
export const AccordionHeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`;

// Chevron Icon
export const ChevronIcon = styled.i<{
  isOpen: boolean;
  variant?: "normal" | "big";
}>`
  width: ${({ variant }) => (variant === "big" ? "14px" : "12px")};
  height: ${({ variant }) => (variant === "big" ? "16px" : "8px")};
  size: ${({ variant }) => (variant === "big" ? "16px" : "8px")};
  transform: ${({ isOpen }) => (isOpen ? "rotate(180deg)" : "rotate(0deg)")};
  transition: transform 0.3s ease;
  color: ${colorGuide.lightComponents.accordion.color};
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: ${({ variant }) => (variant === "big" ? "900" : "400")};
`;

// Accordion Content
export const AccordionContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
`;

// Styled Container for Accordion Detail
export const AccordionDetailContainer = styled.div`
  height: auto;
  width: 100%;
  box-sizing: border-box;
  border-radius: 8px;
  margin-top: 8px;
`;

// Styled Line
// Accordion.styles.ts
export const AccordionLine = styled.div<{ lineColor?: string }>`
  align-self: center;
  height: 1px;
  width: 100%;
  background-color: ${({ lineColor }) =>
    lineColor || colorGuide.lightComponents.accordion.accordionLineColor};
`;
